import {
  DismissStandardSunsetRenewalBannerDocument,
  DismissStandardSunsetRenewalBannerMutation
} from '~/api/graphql';
import { client } from '~/api/client';

export const dismissStandardSunsetRenewalBanner = async () => {
  const result = await client.mutate<DismissStandardSunsetRenewalBannerMutation>({
    mutation: DismissStandardSunsetRenewalBannerDocument
  });
  return result.data?.dismissStandardSunsetRenewalBanner;
};
